import Swiper from "swiper";
import { Grid, Navigation, Pagination, Scrollbar, Thumbs, Virtual } from "swiper/modules";

Swiper.use([Navigation, Pagination, Scrollbar, Thumbs, Grid, Virtual]);

import gsap from "gsap";

import Splide from "@splidejs/splide";

function animateSvg() {

    if (window.innerWidth < 992) return;
    // step-2: tendina orizzontale, step-3: tendina verticale con GSAP e clip-path
    const svgContainer = document.querySelector('.svg-wrapper');
    if (!svgContainer) return;

    const step2 = svgContainer.querySelector('.step-2');
    const step3 = svgContainer.querySelector('.step-3');

    if (!step2 || !step3) return;

    // Imposta stato iniziale: nascosti
    gsap.set(step2, { clipPath: 'inset(0 100% 0 0)' }); // nascosto a destra
    gsap.set(step3, { clipPath: 'inset(0 0 100% 0)' }); // nascosto in basso

    let timeline;
    let lastScrollY = window.scrollY;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const currentScrollY = window.scrollY;
            const isScrollingUp = currentScrollY < lastScrollY;
            lastScrollY = currentScrollY;

            // console.log(entry.isIntersecting);

            if (entry.isIntersecting) {
                // console.log('Animazione di apertura');
                // Sezione entra nel viewport: crea timeline di animazione
                if (timeline) timeline.kill(); // cancella timeline precedente se esiste

                timeline = gsap.timeline();
                timeline
                    .to(step2, {
                        clipPath: 'inset(0 0 0 0)',
                        duration: 2,
                        ease: 'power2.out'
                    })
                    .to(step3, {
                        clipPath: 'inset(0 0 0 0)',
                        duration: 2,
                        ease: 'power2.out'
                    }, '-=0.5'); // overlap di 0.3s

            } else if (isScrollingUp) {

                // console.log('Animazione di chiusura');

                // Sezione esce dal viewport E si sta scrollando verso l'alto: reverse
                if (timeline) timeline.kill();

                timeline = gsap.timeline();
                timeline
                    .to(step3, {
                        clipPath: 'inset(0 0 100% 0)',
                        duration: 1,
                        ease: 'power2.in'
                    })
                    .to(step2, {
                        clipPath: 'inset(0 100% 0 0)',
                        duration: 1,
                        ease: 'power2.in'
                    }, '-=0.5');
            }
        });
    }, { threshold: 0 });

    observer.observe(svgContainer);
}

function animateSvgMobile() {

    if (window.innerWidth >= 992) return;

    // step-2: tendina orizzontale, step-3: tendina verticale con GSAP e clip-path
    const svgContainer = document.querySelector('.svg-wrapper-mobile');
    if (!svgContainer) return;

    const step2 = svgContainer.querySelector('.step-2');
    const step3 = svgContainer.querySelector('.step-3');

    if (!step2 || !step3) return;

    // Imposta stato iniziale: nascosti
    gsap.set(step2, { clipPath: 'inset(0 100% 0 0)' }); // nascosto a destra
    gsap.set(step3, { clipPath: 'inset(0 0 100% 0)' }); // nascosto in basso

    let timeline;
    let lastScrollY = window.scrollY;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            const currentScrollY = window.scrollY;
            const isScrollingUp = currentScrollY < lastScrollY;
            lastScrollY = currentScrollY;

            if (entry.isIntersecting) {
                // Sezione entra nel viewport: crea timeline di animazione
                if (timeline) timeline.kill(); // cancella timeline precedente se esiste

                timeline = gsap.timeline();
                timeline
                    .to(step2, {
                        clipPath: 'inset(0 0 0 0)',
                        duration: 2,
                        ease: 'power2.out'
                    })
                    .to(step3, {
                        clipPath: 'inset(0 0 0 0)',
                        duration: 2,
                        ease: 'power2.out'
                    }, '-=0.3'); // overlap di 0.3s
            } else if (isScrollingUp) {
                // Sezione esce dal viewport E si sta scrollando verso l'alto: reverse
                if (timeline) timeline.kill();

                timeline = gsap.timeline();
                timeline
                    .to(step3, {
                        clipPath: 'inset(0 0 100% 0)',
                        duration: 2,
                        ease: 'power2.in'
                    })
                    .to(step2, {
                        clipPath: 'inset(0 100% 0 0)',
                        duration: 2,
                        ease: 'power2.in'
                    }, '-=0.3');
            }
        });
    }, { threshold: 0.3 });

    observer.observe(svgContainer);
}

function setupConfigOptionMore() {
    const moreLinks = document.querySelectorAll('.config-option-more.js-show-more');

    moreLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            const part = this.getAttribute('data-part');
            const type = this.getAttribute('data-type');
            const others = JSON.parse(this.getAttribute('data-others'));

            const parentRow = this.parentElement;
            this.remove();

            for (const [code, imgSrc] of Object.entries(others)) {
                const colDiv = document.createElement('div');
                colDiv.className = 'col config-option';
                colDiv.setAttribute('data-part', part);
                colDiv.setAttribute('data-type', type);
                colDiv.setAttribute('data-code', code);

                const imgWrapper = document.createElement('div');
                imgWrapper.className = 'img-wrapper circle';

                const img = document.createElement('img');
                img.src = imgSrc;
                img.alt = code;
                img.className = 'w-100 h-100 object-fit-cover';
                img.style.aspectRatio = '1 / 1';

                imgWrapper.appendChild(img);
                colDiv.appendChild(imgWrapper);

                const p = document.createElement('p');
                p.className = 'text-center mb-0 fs-14';
                p.innerHTML = `<b>${code}</b>`;

                colDiv.appendChild(p);
                parentRow.appendChild(colDiv);
            }
        });
    });
}

export function initProductModule() {

    if (document.querySelectorAll('.product-header-swiper').length > 0) {
        initializeSwiper('.product-header-swiper', {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
        }, false);
    }


    // Gallery principale del prodotto con miniature
    if (document.querySelectorAll('.product-main-gallery .main-swiper .swiper').length > 0) {
        const productMainGallery = new Swiper('.product-main-gallery .main-swiper .swiper', {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            thumbs: {
                swiper: null, // Sarà impostato dopo l'inizializzazione della galleria delle miniature
            },
            breakpoints: {
                992: {
                    slidesPerView: 1,
                },
            },
        });

        var thumbsImagesWrapper = document.querySelector('.product-main-gallery .thumbs-images');

        // Hide first image
        const firstImage = thumbsImagesWrapper.querySelector('img');
        if (firstImage) {
            firstImage.style.display = 'none';
            firstImage.style.visibility = 'hidden';
        }

        // Calcola l'altezza della galleria in base al quella principale
        function updateImagesHeight() {
            if (!document.querySelector('.product-main-gallery .main-swiper .swiper')) return;

            var thumbsHeight = window.innerWidth < 992 ? false : thumbsImagesWrapper.offsetHeight;
            const mainGalleryImgs = document.querySelectorAll('.product-main-gallery .main-swiper img');
            if (mainGalleryImgs.length > 0 && thumbsHeight) {
                mainGalleryImgs.forEach(img => {
                    img.style.height = thumbsHeight + 'px';
                });
            } else {
                mainGalleryImgs.forEach(img => {
                    img.style.removeProperty('height');
                });
            }
        }

        function setupClickOnThumbs() {
            const thumbImages = document.querySelectorAll('.product-main-gallery .thumbs-images img');
            thumbImages.forEach((thumb, index) => {
                thumb.addEventListener('click', function (e) {
                    e.preventDefault();
                    productMainGallery.slideToLoop(index); // slideToLoop gestisce correttamente l'indice anche in loop
                    // Aggiorna la visibilità delle miniature
                    thumbImages.forEach((img, idx) => {
                        if (idx === index) {
                            img.style.display = 'none';
                            img.style.visibility = 'hidden';
                        } else {
                            img.style.display = '';
                            img.style.visibility = '';
                        }
                    });
                });
            });
        }


        // Aggiorna l'altezza delle miniature all'inizio e al ridimensionamento della finestra
        updateImagesHeight();
        window.addEventListener('resize', updateImagesHeight);
        setupClickOnThumbs();

        document.querySelectorAll('.varianti-item').forEach((item, idx) => {
            item.addEventListener('click', function (e) {
                e.preventDefault();

                // Scroll alla gallery dopo il cambio variante
                if (window.innerWidth < 992) {
                    document.querySelector('.product-main-gallery').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
                }

                document.querySelector('.product-main-gallery .main-swiper').style.opacity = '0';
                document.querySelector('.product-main-gallery .thumbs-images').style.opacity = '0';
                document.querySelector('.product-main-gallery .scrollbar').style.opacity = '0';

                // Show loading
                const loadingDiv = document.createElement('div');
                loadingDiv.className = 'loading-overlay';
                loadingDiv.innerHTML = '<div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div>';
                document.querySelector('.product-main-gallery').appendChild(loadingDiv);

                // Aggiorna selezione attiva
                document.querySelectorAll('.varianti-item').forEach(el => el.classList.remove('active'));

                // Prendi immagini della variante selezionata
                const images = window.productVariantsData[idx];
                if (!images || !images.length) return;

                // Aggiorna HTML della gallery principale e thumbs
                const mainWrapper = document.querySelector('.product-main-gallery .main-swiper .swiper-wrapper');
                const thumbsWrapper = document.querySelector('.product-main-gallery .thumbs-images');
                if (!mainWrapper) return;

                mainWrapper.innerHTML = '';
                thumbsWrapper.innerHTML = '';
                images.forEach((img, idx) => {
                    mainWrapper.innerHTML += `<div class="swiper-slide" data-swiper-slide-index="${idx}"><img src="${img.url}" class="w-100 h-100 object-fit-cover" style="aspect-ratio: 800 / 900;" alt=""></div>`;
                    var imgStyle = '';
                    if (idx === 0) {
                        imgStyle = 'display: none;visibility: hidden;';
                    }
                    thumbsWrapper.innerHTML += `<img src="${img.url}" class="w-100 h-25 object-fit-cover" style="aspect-ratio: 1 / 1;${imgStyle}" alt="">`;
                });


                // Aggiorna Swiper dopo aver modificato il DOM
                var productGallerySwiper = document.querySelector('.product-main-gallery .main-swiper .swiper').swiper;
                productGallerySwiper.update();

                if (window.innerWidth >= 992) {
                    updateImagesHeight();
                    setupClickOnThumbs();
                }

                this.classList.add('active');

                setTimeout(() => {
                    loadingDiv.style.opacity = '0';
                    loadingDiv.remove();
                    document.querySelector('.product-main-gallery .main-swiper').style.opacity = '1';
                    document.querySelector('.product-main-gallery .thumbs-images').style.opacity = '1';
                    document.querySelector('.product-main-gallery .scrollbar').style.opacity = '1';

                }, 800);
            });
        });
    }

    // Swiper gallery prodotto
    if (document.querySelectorAll('.product-gallery-slider').length > 0) {

        // console.log('Init: .product-gallery-slider');

        var element = document.querySelector('.product-gallery-slider');
        var gallerySlider = new Splide(element, {
            type: "slide",
            autoWidth: true,
            focus: 0,
            start: 0,
            fixedHeight: "600px",
            gap: "25px",
            lazyLoad: false,
            omitEnd: true,
            arrows: false,
            pagination: false,
            breakpoints: {
                1199: {
                    gap: "25px",
                    autoWidth: true,
                    fixedHeight: "500px",
                },
                991: {
                    gap: "30px",
                    autoWidth: true,
                    fixedHeight: "400px",
                },
                767: {
                    gap: "40px",
                    autoWidth: true,
                    fixedHeight: "300px",
                },
                565: {
                    gap: "40px",
                    autoWidth: true,
                    fixedHeight: "300px",
                },
            },

        })

        var bar = gallerySlider.root.querySelector('.product-gallery-progress-bar');

        // Updates the bar width whenever the carousel moves:
        gallerySlider.on('mounted move', function () {
            // Ottieni l'indice dell'ultima slide visibile (end) e il numero totale di slide
            var end = gallerySlider.Components.Controller.getEnd() + 1;
            var currentIndex = gallerySlider.index;
            var totalSlides = gallerySlider.length;

            // Se end è 1, usa il numero totale di slide
            var maxPosition = end > 1 ? end : totalSlides;

            if (maxPosition > 0) {
                var rate = Math.min((currentIndex + 1) / maxPosition, 1);
                // console.log('Rate:', rate, 'Width:', String(100 * rate) + '%');
                bar.style.width = String(100 * rate) + '%';
            }
        });

        gallerySlider.on('move', function (newIndex, prevIndex, destIndex) {

            if (newIndex === 0) {
                prevButton.classList.add('disabled');
            } else {
                prevButton.classList.remove('disabled');
            }

            var end = gallerySlider.Components.Controller.getEnd() + 1;
            // destIndex va da 0 a (end - 1), quindi disabilita quando destIndex === end - 1
            if (destIndex >= end - 1) {
                nextButton.classList.add('disabled');
            } else {
                nextButton.classList.remove('disabled');
            }
        });

        gallerySlider.mount();

        var prevButton = document.querySelector('.product-gallery-navigation .slider-button-prev');
        var nextButton = document.querySelector('.product-gallery-navigation .slider-button-next');

        prevButton.classList.add('disabled');

        prevButton.addEventListener('click', function (e) {
            // console.log('Prev clicked, disabled:', this.classList.contains('disabled'));
            gallerySlider.go('-1');
        });

        nextButton.addEventListener('click', function (e) {
            // console.log('Next clicked, disabled:', this.classList.contains('disabled'));
            gallerySlider.go('+1');
        });

        prevButton.addEventListener('touchend', function (e) {
            // console.log('Prev clicked, disabled:', this.classList.contains('disabled'));
            gallerySlider.go('-1');
        });

        nextButton.addEventListener('touchend', function (e) {
            // console.log('Next clicked, disabled:', this.classList.contains('disabled'));
            gallerySlider.go('+1');
        });




    }

    // Swiper prodotti correlati
    if (document.querySelectorAll('.related-products-swiper').length > 0) {
        initializeSwiper('.related-products-swiper', {
            slidesPerView: 2.15,
            spaceBetween: 20,
            loop: false,
            breakpoints: {
                576: {
                    slidesPerView: 2.25,
                },
                992: {
                    slidesPerView: 3.35,
                },
                1400: {
                    slidesPerView: 4,
                },
                1700: {
                    slidesPerView: 5,
                },
                1920: {
                    slidesPerView: 6,
                }
            },
        });
    }

    // Funzionalità "Leggi di più" / "Leggi di meno" con visibilità dinamica
    const toggleTextLink = document.querySelector('.toggle-text');
    const descriptionParagraph = document.querySelector('.product-desc');

    function isClamped(elements) {
        if (elements.length == 0) return false;

        if (elements.length === 1) {
            const el = elements[0];
            return el.scrollHeight - el.clientHeight > 1;
        } else {
            // Se ci sono più paragrafi, consideriamo il testo troncato se almeno uno di essi è troncato
            return Array.from(elements).some(el => el.scrollHeight - el.clientHeight > 1);
        }

        // Verifica se il testo è troncato, tolleranza 1px per differenze mobile
        // return element.scrollHeight - element.clientHeight > 1;
    }

    function updateToggleVisibility() {
        if (!toggleTextLink || !descriptionParagraph) return;

        if (!descriptionParagraph.classList.contains('line-clamp')) return;

        if (isClamped(descriptionParagraph.querySelectorAll('p'))) {
            toggleTextLink.style.display = '';
        } else {
            toggleTextLink.style.display = 'none';
        }
    }

    if (toggleTextLink && descriptionParagraph) {
        updateToggleVisibility();
        toggleTextLink.addEventListener('click', function (e) {
            e.preventDefault();
            if (descriptionParagraph.classList.contains('line-clamp')) {
                descriptionParagraph.classList.remove('line-clamp');
                toggleTextLink.textContent = this.getAttribute('data-text-less') || 'Leggi meno';
            } else {
                descriptionParagraph.classList.add('line-clamp');
                toggleTextLink.textContent = this.getAttribute('data-text-more') || 'Leggi di più';
            }
            // updateToggleVisibility(); Non serve aggiornare la visibilità al click, rimane sempre visibile una volta espanso o compresso
        });
        // Aggiorna la visibilità al resize
        window.addEventListener('resize', updateToggleVisibility);
    }

    // Calcolo altezza di tutti i .pc-wrapper in base all'altezza della prima .family-card


    if (window.innerWidth >= 992) {

        var firstFamilyCard = document.querySelector('.family-card');

        if (firstFamilyCard) {

            var productCardWrappers = document.querySelectorAll('.pc-wrapper');
            var firstCardHeight = firstFamilyCard.clientHeight;

            console.log(firstCardHeight);


            productCardWrappers.forEach(wrapper => {
                wrapper.style.height = firstCardHeight + 'px';
            });
        }

    } else {

        var productCardWrappers = document.querySelectorAll('.pc-wrapper');
        if (productCardWrappers.length != 0) {
            var maxHeight = 0;

            productCardWrappers.forEach(wrapper => {
                if (wrapper.clientHeight > maxHeight) {
                    maxHeight = wrapper.clientHeight;
                }
            });

            productCardWrappers.forEach(wrapper => {
                wrapper.style.height = maxHeight + 'px';
            });
        }
    }

    // Aggiorna al resize
    window.addEventListener('resize', function () {
        if (window.innerWidth >= 992) {
            var firstFamilyCard = document.querySelector('.family-card');

            if (!firstFamilyCard) return;
            var productCardWrappers = document.querySelectorAll('.pc-wrapper');
            var firstCardHeight = firstFamilyCard.clientHeight;

            productCardWrappers.forEach(wrapper => {
                wrapper.style.height = firstCardHeight + 'px';
            });

        } else {
            var productCardWrappers = document.querySelectorAll('.pc-wrapper');
            if (productCardWrappers.length === 0) return;

            var maxHeight = 0;

            productCardWrappers.forEach(wrapper => {
                wrapper.style.height = "auto" // Reset altezza per ricalcolare correttamente

                if (wrapper.clientHeight > maxHeight) {
                    maxHeight = wrapper.clientHeight;
                }
            });

            productCardWrappers.forEach(wrapper => {
                wrapper.style.height = maxHeight + 'px';
            });
        }
    });


    setTimeout(() => {
        // Cerco .product-card .img-wrapper più alta e la imposto a tutte le .product-card .img-wrapper per evitare problemi di allineamento in caso di immagini con aspect ratio diverso
        var imgWrappers = document.querySelectorAll('.product-card.with-variants .img-wrapper');
        if (imgWrappers.length === 0) return;

        var maxHeight = 0;

        imgWrappers.forEach(wrapper => {
            if (wrapper.clientHeight > maxHeight) {
                maxHeight = wrapper.clientHeight;
            }
        });

        imgWrappers.forEach(wrapper => {
            wrapper.style.height = maxHeight + 'px';
        });
    }, 700);

    // Aggiorna al resize
    window.addEventListener('resize', function () {
        var imgWrappers = document.querySelectorAll('.product-card.with-variants .img-wrapper');
        if (imgWrappers.length === 0) return;

        var newMaxHeight = 0;
        imgWrappers.forEach(wrapper => {
            wrapper.style.removeProperty('height'); // Rimuove altezza fissa per ricalcolare correttamente
            if (wrapper.clientHeight > newMaxHeight) {
                newMaxHeight = wrapper.clientHeight;
            }
        });
        imgWrappers.forEach(wrapper => {
            wrapper.style.height = newMaxHeight + 'px';
        });
    });


    setupConfigOptionMore();

    animateSvg();
    animateSvgMobile();

}
